import React from "react";
import styles from "../CustomerReview/CustomerReview.module.css";
import Customer_Data from "../../Data/RO-landing.json";
import Customer_img from "../../images/customer.webp";
import Star from "../../images/5star.jpeg";

const CustomerReview = () => {
  let customer = Customer_Data[0].reviews;
  // console.log(customer);

  return (
    <>
      <h1 id={styles.Customer_heading}>Read What our customers say</h1>
      <div className={styles.container}>
        {customer.map((data, index) => {
          return (
            <div className={styles.card}>
              <img id={styles.img_1} src={Customer_img} alt="" />
              <h1>{data.custName}</h1>
              <img id={styles.img_2} src={Star} alt="" />
              <h3>{data.review}</h3>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CustomerReview;
